export default {
	methods: {
		/**
		 * Calculates the total of a seo metric
		 * @param {Array<object>} data - Array of SEO data
		 * @param {string} metric - Name of the metric
		 * @param {number} metricIndex - Index of the value of the metric
		 * @return {number} Returns the total
		 */
		getSeoTotal: (data, metric, metricIndex) => {
			let seoTotal = 0;
			for(var i = 0; i < data.length; i++) {
				if(data[i].dimensions[0].includes(metric)) {
					seoTotal += parseInt(data[i].metrics[0].values[metricIndex]);
				}
			}
			return seoTotal;
		},

		/**
		 * Calculates the total of a seo metric
		 * @param {Array<object>} data - Array of SEO data
		 * @param {string} metric - Name of the metric
		 * @param {number} metricIndex - Index of the value of the metric
		 * @return {number} Returns average for a percent
		 */
		getSeoAverage: (data, metric, metricIndex) => {
			let seoTotal = 0;
			let count = 0;
			for(var i = 0; i < data.length; i++) {
				if(data[i].dimensions[0].includes(metric)) {
					seoTotal += parseFloat(data[i].metrics[0].values[metricIndex]);
					count++;
				}
			}
			return parseFloat(seoTotal / count);
		}
	}
};
